var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-link',{staticClass:"p-footerServiceBanner",class:[
    `p-footerServiceBanner--${_vm.servicePortalId}`,
    `p-footerServiceBanner--${this.$i18n.locale || 'ja'}`,
  ],attrs:{"to":{ name: 'Index', params: { portalId: _vm.servicePortalId } }}},[_c('img',{staticClass:"p-footerServiceBanner__logo",attrs:{"src":_vm.image.url,"width":_vm.image.width,"height":_vm.image.height,"alt":_vm.altText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }